import React from 'react'
import '../../global-style.css'
import classnames from 'classnames'
import S from './WaitingToVerify.module.css'
import AccountUtil from '../../util/AccountUtil'
import Button from '../Button'

export default class WaitingToVerify extends React.Component {

  constructor( props ) {
    super( props ) // signedOut
    this.state = {
      error : false,
      message : '',
    }
  }

  resendEmail = async () => {
    const result = await AccountUtil.sendEmailVerification()
    if ( result ) {
      this.setState( { error : false, message : 'Verification email sent.' }, this.signOut )
    } else {
      this.setState( { error : true, message : 'Error sending verification email.' } )
    }
  }

  getMessageClasses = () => {
    const { error } = this.state;
    if ( error ) {
      return classnames( S.message, S.error )
    }
    return S.message
  }

  signOut = async () => {
    await AccountUtil.signOut()
    const { signedOut } = this.props
    signedOut()
  }

  render() {
    const { message } = this.state
    return (
      <div className={S.container}>
        <div className={S.text}>
          <p>Your Script Keeper accout is not yet verified.</p>
          <p>Please check your email and click the link to verify your account.</p>
        </div>
        <div className={this.getMessageClasses()}>{message}</div>
        <div className={S.buttons}>
          <Button scheme="tertiary" onClick={this.signOut}>Sign Out</Button>
          <Button scheme="primaryInverted" onClick={this.resendEmail}>Resend Verification Email</Button>
        </div>
      </div>
    )
  }
}
